
export default [
	{
		path: '/admin/customer-loan-purposes',
		name: 'customer-loan-purpose',
		meta: { requiresAuth: true },
		component: () => import('@/pages/credit-operation/customer-loan-purpose')
	}
]
